export function searchHelper(http, query, type, options) {
    return http.get('/search', {
        params: Object.assign(Object.assign({}, options), { q: query, type }),
    });
}
